
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/giveaway/[slug]",
      function () {
        return require("private-next-pages/giveaway/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/giveaway/[slug]"])
      });
    }
  